import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {HolidayDetail} from "./holiday-detail";

const HolidayDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/holidays');
    }

    return (
        <HolidayDetail id={id ? parseInt(id) : null} onClose={onClose}/>
    )

});

export default HolidayDetailPage;
